<template>
  <div id="page-product-details">
    <section-products-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Product"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'facilities.sections.products.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import SectionProductsForm from './SectionProductsForm';

export default {
  name: "SectionRiskCodeCreate",
  components: {
    SectionProductsForm,
  },
  mixins: [NotificationMixin,SaveModelMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const references = [
        'Product_FK',
        'PrintIssueSystem_FK',
        'PrintIssueMethod_FK',
      ]

      this.setReferences(references);
      params.Section_FK = this.$route.params.sectionId;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      try {
        const {data} = await this.$api.facilities.sections.createProduct(
          params,
          this.$route.params.sectionId
        );
        this.notifySuccess('Product created');
        await this.$router.push({ name: 'facilities.sections.products.list' })
      } catch (e) {
        this.notifyError('Section failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
